export const Videos = {
  KINETEK_HERO: '/kinetek_hero.mp4'
};
